/* eslint-disable */
import _ from 'underscore';
import {Country, Note} from "../store/types";

export default (
    {countries, countryConditions, limit = 3}:
        { countries: number[], countryConditions: Country[], limit?: number }): Note[] =>
    _.chain(countryConditions)
        .filter((countryConditions) => ~countries.indexOf(countryConditions.id))
        .map((countryConditions) => countryConditions.notes)
        .flatten()
        .sortBy((note) => note.priority)
        .uniq((note) => note.id)
        .slice(0, limit)
        .value()